import { AUTH_TOKEN } from "../constants";

export const getToken = () => {
  const token = window.localStorage.getItem(AUTH_TOKEN);
  return token;
};
